import axios from 'axios';
import { Component } from 'react';
import { Card, Container, Image, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { GET } from '../../api';
import reportCardThumb from '../../assets/images/report-card-thumb.png';
import GeneralCard from '../../helpers/GeneralCard';
import { t } from '../../helpers/translation_helper';
import Header from '../_partials/Header/_Header';
import NavBar from '../_partials/NavBar/_NavBar';
import { White } from '../../helpers/brand_colors_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { trimThisDown } from '../../helpers/general_helpers';

/**
 * ReportCardGenerator Component
 */
class ReportCardGenerator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Reportcards: {
        openSearch: false,
        toggleSearch: () => this.setState({ Reportcards: { ...this.state.Reportcards, openSearch: !this.state.Reportcards.openSearch, search: '' } }, () => {
          if (!this.state.Reportcards.openSearch) {
            this.getReportCards()
          }
        }),
        changeSearch: (search = '') => this.setState({ Reportcards: { ...this.state.Reportcards, search } }, () => this.getReportCards()),
        search: '',
        orderName: 'Name ASC',
        order: 'reportcards.repcard_id',
        dir: 'ASC',
        changeOrder: (orderName = 'Name ASC', order = 'reportcards.repcard_id', dir = 'DESC') => this.setState({ Reportcards: { ...this.state.Reportcards, orderName, order, dir } }, () => this.getReportCards()),
        limit: 100,
        offset: 0,
        data: null,
        total_count: 0,
        total_count_filtered: 0,
        refreshing: false,
        finished: false,
      },
      GradeBooks: {
        openSearch: false,
        toggleSearch: () => this.setState({ GradeBooks: { ...this.state.GradeBooks, openSearch: !this.state.GradeBooks.openSearch, search: '' } }, () => {
          if (!this.state.GradeBooks.openSearch) {
            this.getGradeBooks()
          }
        }),
        changeSearch: (search = '') => this.setState({ GradeBooks: { ...this.state.GradeBooks, search } }, () => this.getGradeBooks()),
        search: '',
        orderName: 'Name ASC',
        order: 'gradebook_reports.gbr_id',
        dir: 'ASC',
        changeOrder: (orderName = 'Name ASC', order = 'gradebook_reports.gbr_id', dir = 'DESC') => this.setState({ GradeBooks: { ...this.state.GradeBooks, orderName, order, dir } }, () => this.getGradeBooks()),
        limit: 100,
        offset: 0,
        data: null,
        total_count: 0,
        total_count_filtered: 0,
        refreshing: false,
        finished: false,
      },
    }
  }

  componentDidMount() {
    this.getReportCards()
    this.getGradeBooks()
  }

  refreshData = () => {
    this.setState({
      Reportcards: {
        ...this.state.Reportcards,
        limit: 100,
        offset: 0,
        data: [],
        total_count: 0,
        total_count_filtered: 0,
        refreshing: false,
        finished: false,
      },
    }, () => this.getReportCards());
  }

  refreshData2 = () => {
    this.setState({
      GradeBooks: {
        ...this.state.GradeBooks,
        limit: 100,
        offset: 0,
        data: [],
        total_count: 0,
        total_count_filtered: 0,
        refreshing: false,
        finished: false,
      },
    }, () => this.getGradeBooks());
  }

  getReportCards = async () => {
    if (this.getReportCardsReq) {
      this.getReportCardsReq.abort();
    }
    this.getReportCardsReq = new AbortController();

    this.setState({
      Reportcards: {
        ...this.state.Reportcards,
        refreshing: true
      }
    })

    try {
      const res = await GET('report-card-generator/get',
        {
          params: {
            search: this.state.Reportcards.search,
            order: this.state.Reportcards.order,
            dir: this.state.Reportcards.dir,
            limit: this.state.Reportcards.limit,
            offset: this.state.Reportcards.offset,
            class_id: this.props.selectedChild.class_id,
            child_id: this.props.selectedChild.child_id,
          },
          signal: this.getReportCardsReq.signal,
        }
      );

      this.setState({
        Reportcards: {
          ...this.state.Reportcards,
          data: res.data.data,
          total_count: res.data.total_count,
          total_count_filtered: res.data.total_count_filtered,
          refreshing: false,
          finished: true
        },
      });
    } catch (err) {
      console.log('err', err)
      if (axios.isCancel(err)) {

      } else {
        toast.error(t('Something went wrong while fetching data!'));
      }
    }
  }

  getGradeBooks = async () => {
    if (this.getGradeBooksReq) {
      this.getGradeBooksReq.abort();
    }
    this.getGradeBooksReq = new AbortController();

    this.setState({
      GradeBooks: {
        ...this.state.GradeBooks,
        refreshing: true
      }
    })

    try {
      const res = await GET('report-card-generator/get-gradebooks',
        {
          params: {
            search: this.state.GradeBooks.search,
            order: this.state.GradeBooks.order,
            dir: this.state.GradeBooks.dir,
            limit: this.state.GradeBooks.limit,
            offset: this.state.GradeBooks.offset,
            class_id: this.props.selectedChild.class_id,
            child_id: this.props.selectedChild.child_id,
            parent_id: this.props.selectedChild.parent_id,
          },
          signal: this.getGradeBooksReq.signal,
        }
      );

      this.setState({
        GradeBooks: {
          ...this.state.GradeBooks,
          data: res.data.data,
          total_count: res.data.total_count,
          total_count_filtered: res.data.total_count_filtered,
          refreshing: false,
          finished: true
        },
      });
    } catch (err) {
      console.log('err', err)
      if (axios.isCancel(err)) {
      } else {
        toast.error(t('Something went wrong while fetching data!'));
      }
    }
  }

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    const { Reportcards, GradeBooks } = this.state
    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('Reports')} backBtn={true} func={[this.refreshData, this.refreshData2]} showChildSelector={true} />

            <div className='d-flex flex-row'>
              <div style={{ flex: 1 }} className='pe-1'>
                <Card className='border-0' style={{ borderRadius: '20px' }}>
                  <Card.Header
                    style={{
                      backgroundColor: '#fff',
                      borderTopLeftRadius: '20px',
                      borderTopRightRadius: '20px',
                    }}>
                    {t('Report Card')}
                  </Card.Header>
                  <Card.Body>
                    {!Reportcards.data &&
                      <div className='d-flex justify-content-center'>
                        <Spinner animation="grow" />
                      </div>
                    }
                    {Reportcards.data && Reportcards.data.length == 0 &&
                      <div className='d-flex justify-content-center'>
                        {t('No Data Found!')}
                      </div>
                    }
                    <div className='d-flex flex-row flex-wrap'>
                      {Reportcards.data && Reportcards.data.map((v, index) => {
                        let acs_ids = v.acs_ids
                        let URL = process.env.REACT_APP_API_URL2 + "report-card-generator/generate-reportcard?" +
                          "auth_key=" + this.props.authData.authKey +
                          "&tenant_id=" + this.props.authData.centerData.tenant_id +
                          "&child_id=" + this.props.selectedChild.child_id +
                          "&class_id=" + this.props.selectedChild.class_id +
                          "&agegroup_id=" + this.props.selectedChild.agegroup_id +
                          "&repcard_id=" + v.repcard_id +
                          "&acs_ids=" + acs_ids +
                          "&center_id=" + v.center_id +
                          "&center_uuid=" + this.props.authData.centerData.center_uuid;

                        return <div className='d-flex flex-column justify-content-between cursor-pointer' key={index} style={{ width: '50%', }} onClick={() => window.open(URL, '_blank')}>
                          <div style={{ margin: '10px', padding: '10px', backgroundColor: White, borderRadius: '1rem', position: 'relative', boxShadow: '-1px 2px 16px 2px rgba(0,0,0,0.1)', }} className='d-flex flex-column'>
                            <div className='d-flex flex-row'>
                              <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 30 }} color='rgb(220, 53, 69)' />
                              <div className='d-flex justify-content-between ps-2'>
                                <div>
                                  <div><strong style={{ fontSize: '1rem' }}>{v.repcard_pdf_title}</strong></div>
                                  {v.repcard_pdf_title_2 && <div className='mx-1 text-muted' style={{ fontSize: '0.9rem' }} title={v.repcard_pdf_title_2}>{trimThisDown(v.repcard_pdf_title_2, 45)}</div>}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        let data = {
                          allData: v,
                          name: <div style={{ paddingTop: 5 }}>{v.repcard_pdf_title}</div>,
                          code: null,
                          text1: v.repcard_pdf_title_2,
                          text2: '',
                          description: null,
                          cardImage: reportCardThumb,
                          onClick: () => window.open(URL, '_blank'),
                        }
                        return <GeneralCard data={data} key={index} />;
                      }
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <div style={{ flex: 1 }} className='ps-1'>
                <Card className='border-0' style={{ borderRadius: '20px' }}>
                  <Card.Header
                    style={{
                      backgroundColor: '#fff',
                      borderTopLeftRadius: '20px',
                      borderTopRightRadius: '20px',
                    }}>
                    {t('Gradebook')}
                  </Card.Header>
                  <Card.Body>
                    {!GradeBooks.data &&
                      <div className='d-flex justify-content-center'>
                        <Spinner animation="grow" />
                      </div>
                    }
                    {GradeBooks.data && GradeBooks.data.length == 0 &&
                      <div className='d-flex justify-content-center'>
                        {t('No Data Found!')}
                      </div>
                    }
                    <div className='d-flex flex-row flex-wrap'>
                      {GradeBooks.data && GradeBooks.data.map((v, index) => {
                        // let URL = process.env.REACT_APP_API_URL2 + "report-card-generator/generate-reportcard?" +
                        //   "auth_key=" + this.props.authData.authKey +
                        //   "&tenant_id=" + this.props.authData.centerData.tenant_id;
                        // let data = {
                        //   allData: v,
                        //   name: <div style={{ paddingTop: 5 }}>{v.repcard_pdf_title}</div>,
                        //   code: null,
                        //   text1: v.repcard_pdf_title_2,
                        //   text2: '',
                        //   description: null,
                        //   cardImage: reportCardThumb,
                        //   onClick: () => window.open(URL, '_blank'),
                        // }
                        // return <GeneralCard data={data} key={index} />;

                        let URL = v.ut_url +
                          "&auth_key=" + this.props.authData.authKey +
                          "&tenant_id=" + this.props.authData.centerData.tenant_id;
                        return <div className='d-flex flex-column justify-content-between cursor-pointer' key={index} style={{ width: '50%', }} onClick={() => window.open(URL, '_blank')}>
                          <div style={{ margin: '10px', padding: '10px', backgroundColor: White, borderRadius: '1rem', position: 'relative', boxShadow: '-1px 2px 16px 2px rgba(0,0,0,0.1)', }} className='d-flex flex-column'>
                            <div className='d-flex flex-row'>
                              <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 30 }} color='rgb(220, 53, 69)' />
                              <div className='d-flex justify-content-between ps-2'>
                                <div>
                                  <div><strong style={{ fontSize: '1rem' }}>{v.ut_title}</strong></div>
                                  {v.ut_description && <div className='mx-1 text-muted' style={{ fontSize: '0.9rem' }} title={v.ut_description}>{trimThisDown(v.ut_description, 45)}</div>}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      )}
                      {/* LOAD MORE INCOMPLETE */}
                      {/* <div className='d-flex flex-column justify-content-between cursor-pointer' style={{ width: '100%', }} onClick={() => }>
                        <div style={{ margin: '10px', padding: '10px', backgroundColor: White, borderRadius: '1rem', position: 'relative', boxShadow: '-1px 2px 16px 2px rgba(0,0,0,0.1)', }} className='d-flex flex-column'>
                          <div className='d-flex flex-row justify-content-center align-items-center'>
                            <div><strong style={{ fontSize: '1rem' }}>{t('Load More...')}</strong></div>
                          </div>
                        </div>
                      </div>*/}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>

          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedChild: state.selectedChild.data,
  defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(ReportCardGenerator);
